import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

const FONT_SANS = "'Geist', 'SF Pro Display', -apple-system, sans-serif";
const FONT_MONO = "'Geist Mono', 'SF Mono', monospace";
const API = '/api/chamas';

export default function ChamaWallet({ chamaId, onBack }) {
  const { T } = useTheme();
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('overview');
  const [amount, setAmount] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => { fetchWallet(); }, [chamaId]);

  const fetchWallet = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/${chamaId}/wallet`, { headers: { Authorization: `Bearer ${token}` } });
      const d = await res.json();
      setWallet(d);
    } finally { setLoading(false); }
  };

  const handleAction = async (type) => {
    const amt = parseFloat(amount);
    if (!amt || amt < 50) return setMsg({ type: 'error', text: 'Minimum amount is KES 50' });
    setActionLoading(true); setMsg(null);
    try {
      const res = await fetch(`${API}/${chamaId}/${type}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ amount: amt }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setMsg({ type: 'success', text: data.message });
      setAmount('');
      await fetchWallet();
    } catch (e) { setMsg({ type: 'error', text: e.message }); }
    finally { setActionLoading(false); }
  };

  const card = { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12 };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 28, height: 28, borderRadius: '50%', border: `2px solid ${T.border}`, borderTop: `2px solid ${T.accent}`, animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  const { wallet: w, my_share_pct, my_share_value, my_max_withdraw, reserve_amount, transactions } = wallet;

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: FONT_SANS, color: T.text }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}} @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}`}</style>

      <nav style={{
        position: 'sticky', top: 0, zIndex: 100, height: 56,
        display: 'flex', alignItems: 'center', padding: '0 32px',
        background: `${T.bg}ee`, backdropFilter: 'blur(16px)',
        borderBottom: `1px solid ${T.border}`,
      }}>
        <button onClick={onBack} style={{
          fontSize: 13, color: T.textMuted, padding: '6px 14px', borderRadius: 8,
          border: `1px solid ${T.border}`, background: T.surface, cursor: 'pointer',
          fontFamily: FONT_SANS, display: 'flex', alignItems: 'center', gap: 6,
        }}>← Back</button>
      </nav>

      <div style={{ maxWidth: 680, margin: '0 auto', padding: '32px 24px 80px', animation: 'fadeIn 0.4s ease' }}>

        {/* Hero balance */}
        <div style={{ ...card, padding: '28px 32px', marginBottom: 16 }}>
          <div style={{ fontSize: 10, fontWeight: 500, letterSpacing: '0.14em', textTransform: 'uppercase', color: T.textDim, marginBottom: 10 }}>Chama Pool</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 24 }}>
            <span style={{ color: T.textMuted, fontSize: 16, fontFamily: FONT_MONO }}>KES</span>
            <span style={{ color: T.text, fontSize: 44, fontWeight: 700, fontFamily: FONT_MONO, letterSpacing: '-0.03em', lineHeight: 1 }}>
              {parseFloat(w.wallet_balance).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, background: T.border, borderRadius: 10, overflow: 'hidden' }}>
            {[
              { label: 'My Share', value: `${parseFloat(my_share_pct).toFixed(1)}%`, color: T.accent },
              { label: 'My Share Value', value: `KES ${my_share_value?.toLocaleString()}`, color: T.yes },
              { label: 'Max Withdraw', value: `KES ${my_max_withdraw?.toLocaleString()}`, color: T.gold },
            ].map((s, i) => (
              <div key={i} style={{ background: T.surface, padding: '12px 14px' }}>
                <div style={{ color: T.textDim, fontSize: 10, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 5 }}>{s.label}</div>
                <div style={{ color: s.color, fontSize: 13, fontWeight: 600, fontFamily: FONT_MONO }}>{s.value}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Reserve note */}
<div style={{
  background: T.surface, border: `1px solid ${T.border}`,
  borderRadius: 10, padding: '10px 16px', marginBottom: 20,
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
}}>
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <div style={{
      width: 28, height: 28, borderRadius: 7, flexShrink: 0,
      background: T.surfaceHi, border: `1px solid ${T.border}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4v6m0 4v.01"
          stroke={T.textDim} strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </div>
    <span style={{ color: T.textMuted, fontSize: 12, lineHeight: 1.5 }}>
      20% liquid reserve is always maintained and cannot be traded or withdrawn.
    </span>
  </div>
  <div style={{
    flexShrink: 0, fontFamily: FONT_MONO, fontSize: 12, fontWeight: 600,
    color: T.textMuted, background: T.surfaceHi,
    border: `1px solid ${T.border}`, borderRadius: 6, padding: '3px 10px',
    whiteSpace: 'nowrap',
  }}>
    KES {reserve_amount?.toLocaleString()}
  </div>
</div>

        {/* Tabs */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, background: T.border, borderRadius: 10, overflow: 'hidden', marginBottom: 20 }}>
          {['overview', 'deposit', 'withdraw'].map(t => (
            <button key={t} onClick={() => { setTab(t); setMsg(null); setAmount(''); }} style={{
              padding: '12px', background: tab === t ? T.surfaceHi : T.surface,
              border: 'none', cursor: 'pointer', fontFamily: FONT_SANS, fontSize: 13,
              fontWeight: tab === t ? 600 : 400,
              color: tab === t ? T.text : T.textMuted,
              borderBottom: tab === t ? `2px solid ${T.accent}` : '2px solid transparent',
              transition: 'all 0.15s', textTransform: 'capitalize',
            }}>{t}</button>
          ))}
        </div>

        {/* Tab content */}
        {tab === 'overview' ? (
          <TransactionList transactions={transactions} T={T} />
        ) : (
          <div style={{ ...card, padding: '24px' }}>
            <h3 style={{ margin: '0 0 6px', fontSize: 15, fontWeight: 600, color: T.text, textTransform: 'capitalize' }}>{tab} Funds</h3>
            <p style={{ color: T.textMuted, fontSize: 13, margin: '0 0 20px', lineHeight: 1.6 }}>
              {tab === 'deposit'
                ? 'Funds are pulled from your Mino personal wallet. Your share percentage increases proportionally.'
                : `You can withdraw up to KES ${my_max_withdraw?.toLocaleString()} (respecting the 20% reserve + 7-day hold period).`}
            </p>
            <div style={{ position: 'relative', marginBottom: 16 }}>
              <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: T.textDim, fontSize: 13, fontFamily: FONT_MONO, pointerEvents: 'none' }}>KES</div>
              <input
                type="number" min={50} value={amount} onChange={e => setAmount(e.target.value)}
                placeholder="Minimum KES 50"
                style={{
                  width: '100%', boxSizing: 'border-box',
                  background: T.surfaceHi, border: `1px solid ${T.border}`, borderRadius: 10,
                  padding: '12px 14px 12px 48px', color: T.text,
                  fontFamily: FONT_MONO, fontSize: 16, outline: 'none',
                }}
              />
            </div>
            {msg && (
              <div style={{
                marginBottom: 14, borderRadius: 8, padding: '10px 14px',
                background: msg.type === 'success' ? T.yesDim : T.noDim,
                border: `1px solid ${msg.type === 'success' ? T.yes : T.no}30`,
                color: msg.type === 'success' ? T.yes : T.no, fontSize: 13,
              }}>{msg.text}</div>
            )}
            <button onClick={() => handleAction(tab)} disabled={actionLoading} style={{
              width: '100%', padding: '13px', borderRadius: 10, border: 'none',
              background: T.accent, color: '#fff', fontFamily: FONT_SANS,
              fontSize: 14, fontWeight: 600, cursor: actionLoading ? 'not-allowed' : 'pointer',
              opacity: actionLoading ? 0.6 : 1, transition: 'opacity 0.2s',
            }}>
              {actionLoading ? 'Processing...' : `Confirm ${tab === 'deposit' ? 'Deposit' : 'Withdrawal'}`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function TransactionList({ transactions, T }) {
  const card = { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12 };
  if (!transactions?.length) return (
    <div style={{ ...card, padding: 32, textAlign: 'center', color: T.textDim, fontSize: 14 }}>No transactions yet</div>
  );
  const typeConfig = {
    deposit: { label: 'Deposit', color: T.yes, sign: '+' },
    withdrawal: { label: 'Withdrawal', color: T.no, sign: '-' },
    trade_placed: { label: 'Trade', color: T.accent, sign: '-' },
    trade_returned: { label: 'Return', color: T.yes, sign: '+' },
  };
  return (
    <div style={{ ...card, overflow: 'hidden' }}>
      {transactions.map((tx, i) => {
        const conf = typeConfig[tx.type] || { label: tx.type, color: T.textDim, sign: '' };
        return (
          <div key={tx.id} style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
            borderBottom: i < transactions.length - 1 ? `1px solid ${T.border}` : 'none',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = T.surfaceHi}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <div style={{
              width: 34, height: 34, borderRadius: 9, flexShrink: 0,
              background: `${conf.color}14`, border: `1px solid ${conf.color}28`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: conf.color, fontSize: 14, fontWeight: 700,
            }}>{conf.sign}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: T.text, fontSize: 13, fontWeight: 500 }}>{conf.label}</div>
              <div style={{ color: T.textDim, fontSize: 11, marginTop: 2 }}>
                {tx.username} · {new Date(tx.created_at).toLocaleDateString('en-KE', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
            <div style={{ color: conf.color, fontFamily: FONT_MONO, fontSize: 14, fontWeight: 600 }}>
              {conf.sign}KES {parseFloat(tx.amount).toLocaleString()}
            </div>
          </div>
        );
      })}
    </div>
  );
}